import styled from 'styled-components';
import { caption, link2 } from 'ui/theme';

export const LinkAction = styled.span`
    ${caption}
    ${link2}
    font-size: inherit;
`;
